package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class LoginWithAppleUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(): Result<Unit> {
        return authRepository.loginWithApple()
    }
}
